/**
 * @file add-technical-details.tsx
 * @deprecated Copied to app/modules/procurement/pages/master/technical-details/add-technical-details.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/master/technical-details/add-technical-details
 * @description This component allows users to add new technical details for various categories
 * within the uProcure master data. It provides a form to define technical fields
 * (like name, input type, and selection options) and handles their validation and submission.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Category API: correctly uses master.categoryList + warehouse (uprocure uses DEFAULT.CATEGORIES).
 * @todo Permission: only hasPermission(Add); add hasModulePermission(TechnicalDetails) like view page.
 * @todo Warehouse refetch: fetchTabs runs on mount only; refetch categories when selectedWarehouse changes.
 * @todo Remove unused imports: getKey, warehouseStoreString (if still unused).
 * @todo Remove duplicate h1 when PageTitle is used on the route wrapper.
 */

import { Button, Card, Col, Form, Nav, Row, Tab } from "react-bootstrap";
import { CreatableSelectTable } from "../../../../custom/Select/CreatableSelectTable";
import { CustomSelectTable2 } from "../../../../custom/Select/custom-select-table";
import CrossRed from "../../../../../_admin/assets/media/svg_uTrade/cross-red.svg";
import PlusBlue from "../../../../../_admin/assets/media/svg_uTrade/plus-blue.svg";
import errorGray from "../../../../../_admin/assets/media/svg_uTrade/error-warning_gray.svg";
import EditTechnicalField from "../../../../modals/edit-technical-field";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { success } from "../../../../../Global/toast";
import { masterToast } from "../../../../../utils/toast";
import APICallService from "../../../../../api/apiCallService";
import { master } from "../../../../../api/apiEndPoints";
import Loader from "../../../../../Global/loader";
import {
  Add,
  SingleLineText,
  TechnicalDetails,
} from "../../../../../utils/constants";
import { SingleSelection } from "../../../../../utils/constants";
import { MultiLineText } from "../../../../../utils/constants";
import { MultiSelection } from "../../../../../utils/constants";
import { DateSelection } from "../../../../../utils/constants";
import clsx from "clsx";
import { technicalDetailsJSON } from "../../../../../api/apiJSON/master";
import { technicalDetailsOptions } from "../../../../../utils/staticJSON";
import { CustomSelect } from "../../../../custom/Select/CustomSelect";
import Method from "../../../../../utils/methods";
import { useAuth } from "../../../auth";
import { getKey } from "../../../../../Global/history";
import { warehouse as warehouseStoreString } from "../../../../../utils/storeString";
import { useWarehouse } from "../../../../context/WarehouseContext";

const AddTechnicalDetails = () => {
  const { selectedWarehouse } = useWarehouse();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [technical, setTechnical] = useState<any>([]);
  const [validations, setValidations] = useState<any>([]);
  const [showTechnicalFiledModal, setShowTechnicalFiledModal] = useState(false);
  const [active, setActive] = useState(0);
  const [defaultValue, setDefaultValue] = useState(0);
  const [tabs, setTabs] = useState<any>([]);
  const [fetchLoader, setFetchLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<any>();
  const [options, setOptions] = useState<any>([]);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [multiOptions, setMultiOptions] = useState<any>([]);

  useEffect(() => {
    (async () => {
      if (!Method.hasPermission(TechnicalDetails, Add, currentUser)) {
        return window.history.back();
      }
      await fetchTabs();
    })();
  }, []);
  const fetchTabs = async () => {
    setFetchLoader(true);
    const params: any = {
      categoriesDepth: 1,
    };
    if (selectedWarehouse?.value) {
      params.warehouse = selectedWarehouse?.value;
    }
    let apiService = new APICallService(
      master.categoryList,
      params,
      "",
      "",
      "",
      "",
      TechnicalDetails,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.records) {
      setTabs(response.records);
      let data = [];
      let validations = [];
      for (let i = 0; i < response.records.length; i++) {
        data.push({
          category: response.records[i]._id,
          fields: [{ name: "", type: SingleLineText }],
        });
        validations.push({
          category: false,
          fields: [{ name: false, options: false, type: SingleLineText }],
        });
      }
      setValidations(validations);
      setTechnical(data);
    }
    setFetchLoader(false);
  };
  const handleClose = () => {
    setShowTechnicalFiledModal(false);
  };
  const handleActive = (event: any, id: string) => {
    let technicalTemp = [...technical];
    let validationTemp = [...validations];
    let status: any = [];
    // technicalTemp.map((techVal: any, index: number) => {
    //   techVal.fields.map((fieldVal: any, idx: number) => {
    //     let data = { name: false, options: false }
    //     if (!fieldVal.name) {
    //       validationTemp[index].fields[idx].name = true
    //       data = {
    //         ...data,
    //         name: true,
    //       }
    //     } else {
    //       data = {
    //         ...data,
    //         name: false,
    //       }
    //     }
    //     if (fieldVal.type === SingleSelection) {
    //       validationTemp[index].fields[idx].options = false
    //       data = {
    //         ...data,
    //         options: false,
    //       }
    //       if (!fieldVal.options.length) {
    //         validationTemp[index].fields[idx].options = true
    //         data = {
    //           ...data,
    //           options: true,
    //         }
    //       }
    //     } else {
    //       data = {
    //         ...data,
    //         options: false,
    //       }
    //     }
    //     status.push(data)
    //   })
    // })
    // const allTrue = status.every(
    //   (obj: any) => obj.name === false && obj.options === false,
    // )
    // if (allTrue) {
    // if (technical.findIndex((val: any) => val.category === id) === -1) {
    //   technicalTemp.push({
    //     category: id,
    //     fields: [{ name: '', type: SingleLineText }],
    //   })
    //   validationTemp.push({
    //     category: false,
    //     fields: [{ name: false, type: SingleLineText }],
    //   })
    // }
    setActive(event);
    // }
    // setValidations(validationTemp)
    // setTechnical(technicalTemp)
  };
  const handleAddMore = (index: number, fieldIndex: number) => {
    let temp: any = [...technical];
    let validationTemp: any = [...validations];
    let status: any = [];
    temp[index].fields.map((fieldVal: any, idx: number) => {
      let data = { name: false, options: false };
      if (!fieldVal.name) {
        validationTemp[index].fields[idx].name = true;
        data = {
          ...data,
          name: true,
        };
      } else {
        data = {
          ...data,
          name: false,
        };
      }
      if (
        fieldVal.type === SingleSelection ||
        fieldVal.type === MultiSelection
      ) {
        validationTemp[index].fields[idx].options = false;
        data = {
          ...data,
          options: false,
        };
        if (!fieldVal.options.length) {
          validationTemp[index].fields[idx].options = true;
          data = {
            ...data,
            options: true,
          };
        }
      } else {
        data = {
          ...data,
          options: false,
        };
      }
      status.push(data);
    });
    const allTrue = status.every(
      (obj: any) => obj.name === false && obj.options === false,
    );
    if (allTrue) {
      temp[index].fields.push({
        name: "",
        type: SingleLineText,
      });
      validationTemp[index].fields.push({
        name: false,
        options: false,
        type: SingleLineText,
      });
    }
    setValidations(validationTemp);
    setTechnical(temp);
  };
  const handleRemove = (fieldIndex: number, index: number) => {
    let temp = [...technical];
    let validationTemp: any = [...validations];
    temp[index].fields.splice(fieldIndex, 1);
    validationTemp[index].fields.splice(fieldIndex, 1);
    setTechnical(temp);
  };
  const handleChange = (event: any, fieldIndex: number, index: number) => {
    let temp = [...technical];
    let validationTemp: any = [...validations];
    temp[index].fields[fieldIndex].type = event.value;
    validationTemp[index].fields[fieldIndex].type = event.value;
    if (event.value === SingleSelection || event.value === MultiSelection) {
      temp[index].fields[fieldIndex].options = [];
    }
    setTechnical(temp);
  };
  const createOption = (label: string) => ({
    label,
    value: label,
    title: label,
  });
  const handleNameChange = (value: any, fieldIndex: number, index: number) => {
    let temp = [...technical];
    let validationTemp = [...validations];
    temp[index].fields[fieldIndex].name = value;
    validationTemp[index].fields[fieldIndex].name = true;
    if (value) {
      validationTemp[index].fields[fieldIndex].name = false;
    }
    setValidations(validationTemp);
    setTechnical(temp);
  };
  const handleMultiSelectChange = (
    inputValue: string,
    fieldIndex: number,
    index: number,
  ) => {
    let temp = [...technical];
    let validationTemp = [...validations];
    if (inputValue.length > 0) {
      validationTemp[index].fields[fieldIndex].options = false;
    } else {
      validationTemp[index].fields[fieldIndex].options = true;
    }
    temp[index].fields[fieldIndex].options = inputValue;
    setTechnical(temp);
  };
  const handleMultiSelect = (
    inputValue: string,
    fieldIndex: number,
    index: number,
  ) => {
    let temp = [...technical];
    const newOption = createOption(inputValue);
    temp[index].fields[fieldIndex].options = [
      ...temp[index].fields[fieldIndex].options,
      newOption,
    ];
    setTechnical(temp);
  };
  const handleInputChange = (
    inputValue: string,
    fieldIndex: number,
    index: number,
  ) => {
    let temp = [...technical];
    temp[index].fields[fieldIndex].inputValue = inputValue;
    setTechnical(temp);
  };
  const handleKeyDown = (event: any, fieldIndex: number, index: number) => {
    switch (event.key) {
      case "Enter":
      case "Tab":
        if (event.target.value.trimStart().length > 0) {
          let temp = [...technical];
          const newOption = createOption(event.target.value.trimStart());
          temp[index].fields[fieldIndex].options = [
            ...temp[index].fields[fieldIndex].options,
            newOption,
          ];
          let validationTemp = [...validations];
          if (temp[index].fields[fieldIndex].options.length > 0) {
            validationTemp[index].fields[fieldIndex].options = false;
          } else {
            validationTemp[index].fields[fieldIndex].options = true;
          }
          temp[index].fields[fieldIndex].inputValue = "";
          setTechnical(temp);
        }
        event.preventDefault();
    }
  };
  const handleSave = async () => {
    let temp = [...technical];
    let validationTemp = [...validations];
    temp.map((val: any, index: number) => {
      val.fields.map((fieldVal: any, idx: number) => {
        if (val.fields.length > 1) {
          if (idx !== val.fields.length - 1) {
            if (!fieldVal.name) {
              validationTemp[index].fields[idx].name = true;
            }
            if (
              fieldVal.type === SingleSelection ||
              fieldVal.type === MultiSelection
            ) {
              validationTemp[index].fields[idx].options = false;
              if (!fieldVal.options.length) {
                validationTemp[index].fields[idx].options = true;
              }
            }
          }
        } else {
          if (
            fieldVal.type === SingleSelection ||
            fieldVal.type === MultiSelection
          ) {
            validationTemp[index].fields[idx].options = false;
            if (!fieldVal.options.length) {
              validationTemp[index].fields[idx].options = true;
            }
          }
        }
      });
    });
    setValidations(validationTemp);
    let result = await checkValidations();
    if (result) {
      setLoading(true);
      let apiService = new APICallService(
        master.addTechnicalDetails,
        technicalDetailsJSON.addTechnicalDetails({
          technicalDetails: technical,
          auditLogMessage: technical
            .map((item: any) => {
              const validNames = item.fields
                .map((field: any) => field?.name || "")
                .filter((name: string) => name.trim());
              return validNames.length > 0
                ? {
                    type: "Add",
                    name: validNames.join(", "),
                    category:
                      tabs.find((val: any) => val._id === item.category)
                        ?.title || "",
                    warehouseName: selectedWarehouse?.title || "",
                  }
                : null;
            })
            .filter((item: any) => item !== null),
        }),
        "",
        "",
        "",
        "",
        TechnicalDetails,
        selectedWarehouse?.value || null,
      );
      let response = await apiService.callAPI();
      if (response) {
        success(masterToast.addTechnical);
        navigate("/UProcure/master/technical-details");
      }
      setLoading(false);
    }
  };
  const checkValidations = async () => {
    let temp = [...validations];
    let result = temp.every((val: any, index: number) => {
      return val.fields.every((fieldVal: any) => {
        if (
          fieldVal.type === SingleSelection ||
          fieldVal.type === MultiSelection
        ) {
          return fieldVal.name !== true && fieldVal.options !== true;
        } else return fieldVal.name !== true;
      });
    });
    return result;
  };
  const checkValue = async () => {
    let temp = [...technical];
    let result = temp.some((val: any, index: number) => {
      return val.fields.some((fieldVal: any) => {
        if (
          fieldVal.type === SingleSelection ||
          fieldVal.type === MultiSelection
        ) {
          return fieldVal.name !== "" && fieldVal.options.length > 0;
        } else return fieldVal.name !== "";
      });
    });
    return result;
  };
  useEffect(() => {
    (async () => {
      let result = await checkValue();
      if (result) setDisabled(false);
      else setDisabled(true);
    })();
  }, [technical]);
  return (
    <>
      {showTechnicalFiledModal ? (
        <EditTechnicalField
          show={showTechnicalFiledModal}
          handleClose={handleClose}
          moduleName={TechnicalDetails}
        />
      ) : (
        ""
      )}
      <div className="p-5">
        <Row>
          <Col lg={12}>
            <h1 className="fs-22 fw-bolder">Technical details</h1>
            <p className="fs-18 fw-500">
              You can define the required technical details for each category.
            </p>
          </Col>
          {fetchLoader ? (
            <>
              <div className="d-flex justify-content-center">
                <Loader loading={fetchLoader} />
              </div>
            </>
          ) : (
            <>
              {tabs.length ? (
                <>
                  <Col lg={12} className="custom-tabContainer">
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey={defaultValue}
                    >
                      <Row className="variant-categories">
                        <Col lg={"auto"} className="my-2 mb-6">
                          <div className="bg-light border-r8px p-3 px-md-6">
                            <Nav variant="pills">
                              {tabs.map((val: any, index: number) => {
                                return (
                                  <Nav.Item>
                                    <Nav.Link
                                      eventKey={index}
                                      className={
                                        // active === index ? 'check-after' : ' error'
                                        clsx(
                                          validations[index].fields.some(
                                            (e: any) => {
                                              return (
                                                e.name === true ||
                                                e.options == true
                                              );
                                            },
                                          )
                                            ? "error"
                                            : "",
                                          technical[index].fields.some(
                                            (e: any) => {
                                              if (
                                                e.type === SingleSelection ||
                                                e.type === MultiSelection
                                              ) {
                                                return (
                                                  e.name !== "" &&
                                                  e.options.length > 0
                                                );
                                              } else {
                                                return e.name !== "";
                                              }
                                            },
                                          )
                                            ? "check-after"
                                            : "",
                                        )
                                      }
                                      onClick={() => {
                                        handleActive(index, val._id);
                                      }}
                                      active={active === index}
                                    >
                                      {val.title}
                                    </Nav.Link>
                                  </Nav.Item>
                                );
                              })}
                            </Nav>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <Tab.Content>
                            {/*TAB-1*/}
                            <Tab.Pane eventKey={active} active={true}>
                              <Card className="biz-certificate">
                                <Card.Body className="pb-1 pt-3 overflow-hidden">
                                  <div className="table-responsive">
                                    <table className="table align-middle gs-0 gy-4">
                                      <thead>
                                        <tr className="fs-16 fw-600 align-middle h-55px">
                                          <th className="p-0 min-w-250px">
                                            Field name
                                          </th>
                                          <th className="p-0 min-w-215px">
                                            Input type
                                          </th>
                                          <th className="p-0 min-w-lg-425px min-w-300px">
                                            Add options for selections
                                            {/* <img
                                              className="ms-2 pe-1"
                                              src={errorGray}
                                              alt=""
                                            />
                                            <span className="text-gray">
                                              Type option & press tab / enter
                                            </span> */}
                                          </th>
                                          <th className="p-0 text-end min-w-lg-50px">
                                            <img
                                              className="pe-1"
                                              src={errorGray}
                                              alt=""
                                            />
                                            <span className="text-gray">
                                              Type option & press tab / enter
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {technical[active] &&
                                          technical[active].fields.map(
                                            (
                                              fieldVal: any,
                                              fieldIndex: number,
                                            ) => {
                                              return (
                                                <>
                                                  <tr>
                                                    <td>
                                                      <Form.Control
                                                        className={clsx(
                                                          "form-control-table bg-light",
                                                          validations[active]
                                                            .fields[fieldIndex]
                                                            .name
                                                            ? "border-danger"
                                                            : "",
                                                        )}
                                                        type="text"
                                                        placeholder="Type here…"
                                                        value={fieldVal.name}
                                                        onChange={(
                                                          event: any,
                                                        ) => {
                                                          handleNameChange(
                                                            event.target.value.trimStart(),
                                                            fieldIndex,
                                                            active,
                                                          );
                                                        }}
                                                        disabled={loading}
                                                      />
                                                    </td>
                                                    <td>
                                                      <CustomSelect
                                                        minHeight="45px"
                                                        isDisabled={loading}
                                                        controlFontSize={
                                                          "1.077rem"
                                                        }
                                                        onChange={(
                                                          event: any,
                                                        ) => {
                                                          handleChange(
                                                            event,
                                                            fieldIndex,
                                                            active,
                                                          );
                                                        }}
                                                        backgroundColor={
                                                          "#f9f9f9"
                                                        }
                                                        default={
                                                          technicalDetailsOptions[0]
                                                        }
                                                        value={technicalDetailsOptions.filter(
                                                          (val: any) => {
                                                            return (
                                                              val.value ==
                                                              fieldVal.type
                                                            );
                                                          },
                                                        )}
                                                        options={
                                                          technicalDetailsOptions
                                                        }
                                                        isMulti={false}
                                                      />
                                                    </td>
                                                    <td>
                                                      {fieldVal.type ===
                                                      SingleLineText ? (
                                                        <div className="bg-white p-3">
                                                          <span className="fs-15 fw-600">
                                                            The seller can write
                                                            single line text for
                                                            this field.
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        <></>
                                                      )}
                                                      {fieldVal.type ===
                                                      MultiLineText ? (
                                                        <div className="bg-white p-3">
                                                          <span className="fs-15 fw-600">
                                                            The seller can write
                                                            multi line text for
                                                            this field.
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        <></>
                                                      )}
                                                      {fieldVal.type ===
                                                      DateSelection ? (
                                                        <div className="bg-white p-3">
                                                          <span className="fs-15 fw-600">
                                                            The seller can add
                                                            date for this field.
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        <></>
                                                      )}
                                                      {fieldVal.type ===
                                                        SingleSelection ||
                                                      fieldVal.type ===
                                                        MultiSelection ? (
                                                        <CreatableSelectTable
                                                          getOptionLabel={(
                                                            option: any,
                                                          ) => {
                                                            return (
                                                              <>
                                                                {option.title}
                                                              </>
                                                            );
                                                          }}
                                                          border={
                                                            validations[active]
                                                              .fields[
                                                              fieldIndex
                                                            ].options
                                                              ? "#e55451 !important"
                                                              : "#e0e0df"
                                                          }
                                                          inputValue={
                                                            fieldVal.inputValue
                                                          }
                                                          placeholder="Type here..."
                                                          // defaultValue={generalData.variant.Flavour.selectors}
                                                          options={
                                                            fieldVal.options
                                                          }
                                                          isMulti={true}
                                                          onCreateOption={(
                                                            event: any,
                                                          ) => {
                                                            handleMultiSelect(
                                                              event,
                                                              fieldIndex,
                                                              active,
                                                            );
                                                          }}
                                                          onChange={(
                                                            newValue: any,
                                                          ) =>
                                                            handleMultiSelectChange(
                                                              newValue,
                                                              fieldIndex,
                                                              active,
                                                            )
                                                          }
                                                          onInputChange={(
                                                            newValue: any,
                                                          ) =>
                                                            handleInputChange(
                                                              newValue,
                                                              fieldIndex,
                                                              active,
                                                            )
                                                          }
                                                          display="none"
                                                          value={
                                                            fieldVal.options &&
                                                            fieldVal.options.map(
                                                              (
                                                                optionVal: any,
                                                                optionIndex: number,
                                                              ) => {
                                                                return optionVal;
                                                              },
                                                            )
                                                          }
                                                          menuIsOpen={false}
                                                          onKeyDown={(
                                                            event: any,
                                                            newValue: any,
                                                          ) =>
                                                            handleKeyDown(
                                                              event,
                                                              fieldIndex,
                                                              active,
                                                            )
                                                          }
                                                          isDisabled={loading}
                                                        />
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </td>
                                                    <td className="text-end">
                                                      {technical[active].fields
                                                        .length > 1 ? (
                                                        <>
                                                          <button
                                                            type="button"
                                                            className="uw-btn uw-btn-icon btn btn-icon"
                                                            onClick={() => {
                                                              handleRemove(
                                                                fieldIndex,
                                                                active,
                                                              );
                                                            }}
                                                          >
                                                            <img
                                                              width={17}
                                                              height={17}
                                                              src={CrossRed}
                                                              alt=""
                                                            />
                                                          </button>
                                                        </>
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </td>
                                                  </tr>
                                                  {fieldIndex ===
                                                  technical[active].fields
                                                    .length -
                                                    1 ? (
                                                    <>
                                                      <tr>
                                                        <button
                                                          type="button"
                                                          className="uw-btn btn "
                                                          onClick={() => {
                                                            handleAddMore(
                                                              active,
                                                              fieldIndex,
                                                            );
                                                          }}
                                                        >
                                                          <span className="text-primary fs-16 fw-600">
                                                            + Add new
                                                          </span>
                                                        </button>
                                                      </tr>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </>
                                              );
                                            },
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Tab.Pane>
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </Col>
                  <Col lg className="mt-9">
                    <Button className="uw-btn uw-btn-primary uw-btn-lg"
                      variant="primary"
                      size="lg"
                      type="button"
                      disabled={disabled || loading}
                      onClick={() => {
                        handleSave();
                      }}
                    >
                      {loading && (
                        <span
                          className="indicator-progress fs-16 fw-bold"
                          style={{ display: "block" }}
                        >
                          Please wait...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                      {!loading && (
                        <span className="indicator-label fs-16 fw-bold">
                          Save technical detail
                        </span>
                      )}
                    </Button>
                  </Col>{" "}
                </>
              ) : (
                <>
                  <Card className="border border-r10px p-7 pb-3">
                    <Card.Body>
                      <div className="d-flex flex-column flex-center">
                        <h3 className="fs-22 fw-bold">
                          No categories available
                        </h3>
                        <p className="fs-18 fw-500 text-center mw-lg-450px">
                          Please Add Categories to technical details.
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                </>
              )}
            </>
          )}
        </Row>
      </div>
    </>
  );
};
export default AddTechnicalDetails;
